import dayjs from 'dayjs';

export function getDisabledDate(current: dayjs.Dayjs): boolean {
  return current && current.startOf('day').isBefore(dayjs().startOf('day'));
}

export function getDisabledTime(scheduledDate: unknown) {
  const now = dayjs();
  const isToday =
    scheduledDate &&
    dayjs.isDayjs(scheduledDate) &&
    scheduledDate.format('YYYY-MM-DD') === now.format('YYYY-MM-DD');

  if (!isToday) return {};

  const currentHour = now.hour();
  const currentMinute = now.minute();

  return {
    disabledHours: () => Array.from({ length: currentHour }, (_, i) => i),
    disabledMinutes: (selectedHour: number) =>
      selectedHour === currentHour
        ? Array.from({ length: currentMinute + 1 }, (_, i) => i)
        : [],
  };
}
